<template>
    <div>
        <footer>Copyright © 2021 民視新聞網路部 社群中心</footer>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
footer {
    text-align: center;
    background-color: #e18a59;
    color: white;
    padding: 1rem 0;
    padding-bottom: 60px;
    font-weight: 500;
}
</style>
